import React from 'react';
import SIcon from './SIcon';
import { faUnlink } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faUnlink} fa />;

export default Icon;
